import React from "react";

export const PageHero = ({ eyebrow, title, lines, intro }) => (
  <section className="relative pt-[132px] md:pt-[164px] pb-14 md:pb-20 bg-offwhite border-b border-softgray overflow-hidden" data-testid="page-hero">
    <div className="absolute right-0 top-0 h-full w-1/3 pointer-events-none opacity-[0.04]">
      <div className="h-full w-full bg-navy" style={{ clipPath: "polygon(40% 0, 100% 0, 100% 100%, 0% 100%)" }} />
    </div>
    <div className="container-x relative">
      {eyebrow && (
        <div className="flex items-center gap-3 mb-6">
          <span className="h-px w-8 bg-gold" />
          <span className="label-caps text-navy">{eyebrow}</span>
        </div>
      )}
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-navy leading-[1.08] max-w-4xl">
        {lines ? lines.map((l, i) => <span key={i} className="block">{l}</span>) : title}
      </h1>
      {intro && (
        <p className="mt-6 max-w-2xl text-base md:text-lg text-charcoal/80 leading-relaxed">{intro}</p>
      )}
    </div>
  </section>
);

export default PageHero;
